export function hexToHsl(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || "");
  if (!m) return null;
  const n = parseInt(m[1], 16);
  const r = ((n >> 16) & 255) / 255;
  const g = ((n >> 8) & 255) / 255;
  const b = (n & 255) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0;
  let s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

const loadedFonts = new Set(["Inter"]);

function loadFont(family) {
  if (loadedFonts.has(family)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${family.replace(/ /g, "+")}:wght@400;500;600;700;900&display=swap`;
  document.head.appendChild(link);
  loadedFonts.add(family);
}

export function applyBranding(s) {
  if (!s) return;
  const root = document.documentElement;
  const p = hexToHsl(s.primary_color);
  if (p) {
    root.style.setProperty("--primary", p);
    root.style.setProperty("--ring", p);
  }
  const a = hexToHsl(s.accent_color);
  if (a) root.style.setProperty("--accent-custom", a);
  if (s.font_family) {
    loadFont(s.font_family);
    root.style.setProperty("--font-sans", `'${s.font_family}'`);
  }
  if (s.login_title && !window.location.pathname.startsWith("/t/")) document.title = s.login_title;
}
